require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-aiib-water-sector-strategy.json") })
        }
      }, "path---en-us-update-aiib-water-sector-strategy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-aiib-water-sector-strategy!./.cache/json/en-us-update-aiib-water-sector-strategy.json
// module id = 611
// module chunks = 231608221292675